module.exports = __webpack_public_path__ + "img/img3-6.50a0bb92.png";